import { render, staticRenderFns } from "./admin-header.vue?vue&type=template&id=ac89656e&scoped=true&"
import script from "./admin-header.vue?vue&type=script&lang=js&"
export * from "./admin-header.vue?vue&type=script&lang=js&"
import style0 from "./admin-header.vue?vue&type=style&index=0&id=ac89656e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac89656e",
  null
  
)

export default component.exports